"use client";
import { useContext, useEffect, useState } from "react";
import InnerMasterPlanInfo from "./InnerMasterPlanInfo";
import Image from "next/image";
import ImageWithLoader from "../shared/imageWithLoader/ImageWithLoader";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";
import InnerMasterplanPin from "./InnerMasterplanPin";
import useMediaGetter from "@/app/hooks/useMediaGetter";

interface IUnitsFacilities {
	name: {
		en: string;
	};
	description: {
		en: string;
	};
	id: number;
	top_position: number;
	left_position: number;
	top_position_mobile: number;
	left_position_mobile: number;
	image?: {
		media_name: string;
		id: number;
	};
	unit_type?: any;
}
interface IInnerMasterPlan {
	units: IUnitsFacilities[];
	facilities: IUnitsFacilities[];
	handleInquireUnitClick: (unit: string | number) => void;
	backgroundMedia: any;
	setActiveUnitCard: React.Dispatch<React.SetStateAction<boolean>>;
	setActiveUnitCardData: React.Dispatch<React.SetStateAction<any>>;
	sectionTitle?: string
	sectionDescription?: string
	insideAmenitiesDetailsPage ?: boolean
	optimizedImage?: boolean
}

const InnerMasterPlan = ({
	units,
	facilities,
	handleInquireUnitClick,
	backgroundMedia,
	setActiveUnitCard,
	setActiveUnitCardData,
	sectionTitle,
	sectionDescription,
	insideAmenitiesDetailsPage,
	optimizedImage,
}: IInnerMasterPlan) => {
	const [activeTab, setActiveTab] = useState<string | number>("units");
	const [activeCard, setActiveCard] = useState(null);
	const { isMobile, isIpad } = useContext(screenSizeContext);
	const [activeData, setActiveData] = useState<IUnitsFacilities[]>();
	const { imgSrc } = useMediaGetter(backgroundMedia);
	

	useEffect(() => {
			const combinedData = [...units, ...facilities];

			setActiveData(combinedData);
	

	}, [activeTab]);
	

	return (
		<section className="bg-oBlue-150 relative w-full overflow-hidden" >
			<div className="absolute left-1/2 transform -translate-x-1/2 top-[2.75rem] w-[22.5625rem] z-[1] lg:top-[6.35rem]">
				<InnerMasterPlanInfo
					activeTab={activeTab}
					setActiveTab={setActiveTab}
					unitsFound={units?.length > 0}
					facilitiesFound={facilities?.length > 0}
					sectionTitle={sectionTitle}
					sectionDescription={sectionDescription}		
					insideAmenitiesDetailsPage={insideAmenitiesDetailsPage} 			
				/>
			</div>
			<div className="bg_inner_masterplan bg_image_container relative h-[44.88rem]  w-full lg:h-[66.4375rem]">
				{imgSrc && (
					optimizedImage ? (
						<ImageWithLoader
							src={`${imgSrc}`}
							alt="masterplan"
							sizeVariant="fullWidth"
							quality={75}
						/>
					) : (
						<Image
							className="object-cover"
							src={`${imgSrc}`}
							alt="masterplan"
							fill
						/>
					)
				)}
				{activeData?.map((pin) => (
					<InnerMasterplanPin
						key={`${pin.id}${pin?.unit_type ? "u" : "f"}`}
						data={pin}
						activeCard={activeCard}
						setActiveCard={setActiveCard}
						activeTab={activeTab}
						handleInquireUnitClick={handleInquireUnitClick}
						setActiveUnitCard={setActiveUnitCard}
						setActiveUnitCardData={setActiveUnitCardData}
						optimizedImage={optimizedImage}
					/>
				))}
			</div>
		</section>
	);
};

export default InnerMasterPlan;
